import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiCustomerOrdersByIdOptions,
  getApiCustomerOrdersOptions,
  getApiPartnersByIdOptions,
  getApiPartnersOptions,
  type CustomerOrderDetailsDto,
  type GetApiCustomerOrdersByIdError,
  type GetApiCustomerOrdersError,
  type GetApiPartnersByIdError,
  type GetApiPartnersError,
  type PageOfCustomerOrderDto,
  type PageOfPartnerDto,
  type PartnerDto,
} from '@/api';

import {
  toCustomerOrdersQuery,
  type ResolvedCustomerOrdersSearch,
} from '../lib/searchParams';

/** Сколько клиентов показывает поле выбора: дальше пользователь уточняет поиск. */
const PARTNER_OPTIONS_LIMIT = 20;

/** Заказы клиентов из 1С, страница по фильтрам из адреса. */
export const useCustomerOrdersList = (
  resolved: ResolvedCustomerOrdersSearch,
): UseQueryResult<PageOfCustomerOrderDto, GetApiCustomerOrdersError> =>
  useQuery({
    ...getApiCustomerOrdersOptions({ query: toCustomerOrdersQuery(resolved) }),
    placeholderData: (previous) => previous,
  });

/** Карточка заказа со строками. */
export const useCustomerOrder = (
  orderId: string,
): UseQueryResult<CustomerOrderDetailsDto, GetApiCustomerOrdersByIdError> =>
  useQuery(getApiCustomerOrdersByIdOptions({ path: { id: orderId } }));

/** Клиенты для поля фильтра - действующие, по подстроке кода или наименования. */
export const usePartnerOptions = (
  search: string,
): UseQueryResult<PageOfPartnerDto, GetApiPartnersError> =>
  useQuery({
    ...getApiPartnersOptions({
      query: {
        Search: search === '' ? undefined : search,
        PageSize: PARTNER_OPTIONS_LIMIT,
      },
    }),
    placeholderData: (previous) => previous,
  });

/** Клиент из адреса - подпись поля фильтра после перезагрузки страницы. */
export const usePartner = (
  partnerId: string | undefined,
): UseQueryResult<PartnerDto, GetApiPartnersByIdError> =>
  useQuery({
    ...getApiPartnersByIdOptions({ path: { id: partnerId ?? '' } }),
    enabled: partnerId !== undefined,
  });
